import React from 'react';
import { Card, CardContent, Typography, IconButton, Box, Chip, Avatar } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import './UserListItem/UserListItem.css';

const TemplateListItem = ({ template, onEdit, onDelete }) => {
  const getInitials = (name) => {
    if (!name) return "T";
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <Card className="user-list-item">
      <Box className="user-info">
        <Avatar className="user-avatar">
          {getInitials(template.template_name)}
        </Avatar>
        <CardContent className="user-details">
          <Typography variant="h6" component="h3" className="user-name">
            {template.template_name}
          </Typography>
          <Typography variant="body2" className="user-email" style={{ marginTop: 4 }}>
            {template.template_html?.replace(/<[^>]+>/g, '').slice(0, 100) || 'Sem conteúdo'}
          </Typography>
        </CardContent>
      </Box>
      <div className="user-actions">
        <IconButton onClick={onEdit} size="small" style={{ color: '#fff' }}>
          <EditIcon />
        </IconButton>
        <IconButton onClick={onDelete} color="error" size="small">
          <DeleteIcon />
        </IconButton>
      </div>
    </Card>
  );
};

export default TemplateListItem; 